export enum SignUpStepEnum{
  VERIFIED = 'VERIFIED',
  PERSONAL= 'PERSONAL',
  EMAIL = 'EMAIL',
  PASSWORD = 'PASSWORD',
}
